import { Immutable } from "immer";
import React from "react";
import { CAPTION_LIGHT_CLASS_NAME } from "tsi-common-react/src/utils/typography";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Histogram } from "../Histogram";
import { LoadMoreButton } from "../LoadMoreButton";
import { ProductFilter } from "../ProductFilter";
import { RatingFilter } from "../RatingFilter";
import { ReviewList } from "../ReviewList";
import { SortingSelector } from "../SortingSelector";

import styles from "./index.module.scss";

type IProps = Immutable<{
    isLoading: boolean;
}> & {
    onLoadMore: () => void;
};

export const ReviewsViewer = (props: IProps) => {
    return (
        <div className="view-reviews-layout">
            <div className={styles.regionHistogram}>
                <Histogram />
            </div>
            <div id="review-menu" className={styles.reviewMenu}>
                <div className={styles.reviewsRegionFilters}>
                    {/* TODO(i18n): Use t tagged template: {t`Filter:`} */}
                    <div
                        className={concatClassNames([
                            "review-menu-title",
                            CAPTION_LIGHT_CLASS_NAME,
                        ])}
                    >
                        Filter:
                    </div>
                    <RatingFilter />
                    <ProductFilter />
                </div>
                <SortingSelector />
            </div>
            <div className={styles.regionReviews}>
                <div className="view-review-set">
                    <ReviewList />
                </div>
            </div>
            <div className={styles.regionLoadMore}>
                <LoadMoreButton
                    isLoading={props.isLoading}
                    onLoadMore={props.onLoadMore}
                />
            </div>
        </div>
    );
};
